
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import CardListDetailField from "@/components/Base/CardListDetail/CardListDetailField.vue";
import PrepaidTransaction from "@/interfaces/Contracts/PrepaidTransaction";

@Component({ components: { CardListDetailField } })
export default class DetailPrepaidTransactionDetail extends Vue {
  @Prop({ required: true })
  transactions!: PrepaidTransaction[];

  @PropSync("selectedTransaction", { type: Object })
  selectedTransactionSync!: PrepaidTransaction;

  @Watch("transactions")
  defaultSelectedPurchaseItem() {
    this.selectedTransactionSync = this.transactions[0];
  }
}
